import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React from 'react';
import { useRoleLabels } from 'src/hooks/useRoleLabels';
import RelEntityHead from 'src/object-actions/components/RelEntityHead';
import { PaymentAssignments, RelEntity } from '../object-actions/types/types';

interface PaymentAssignmentCardProps {
    assignment: PaymentAssignments;
    extras?: React.ReactNode;
}

const PaymentAssignmentCard: React.FC<PaymentAssignmentCardProps> = ({ assignment, extras }) => {

    const { applyRoleLabels } = useRoleLabels();

    return (
        <Grid container spacing={2}>
            <Grid size={12} container justifyContent="space-between">
                <Grid sx={{ grow: 1 }}>
                    {assignment.athlete ? <RelEntityHead rel={assignment.athlete} label={applyRoleLabels('Athlete')} titleVariant="h5" />
                        : <Typography variant="h5" component="h2">Athlete not set</Typography>}

                </Grid>
                <Grid>
                    {extras}
                </Grid>
            </Grid>

            {/* Guardians */}
            {assignment.parents.length > 0 && (
                <Grid container justifyContent="flex-start" >
                    {assignment.parents.map((parent) => (
                        <Grid key={parent.id}>
                            <RelEntityHead rel={parent as RelEntity<'Users'>} label={applyRoleLabels('Guardian')} />
                        </Grid>
                    ))}
                </Grid>
            )}

            {/* Coaches */}
            {assignment.coaches.length > 0 && (
                <Grid container justifyContent="flex-start" >
                    {assignment.coaches.map((coach) => (
                        <Grid key={coach.id}>
                            <RelEntityHead rel={coach as RelEntity<'Users'>} label={applyRoleLabels('Coach')} />
                        </Grid>
                    ))}
                </Grid>
            )}


        </Grid>
    );
};

export default PaymentAssignmentCard;
